

export const useTranslation = (key)=> (key) ?
	WP_OctaviusRocks_Admin.i18n[key]
	:
	WP_OctaviusRocks_Admin.i18n;